import React, { useState } from 'react';
import { useField } from 'formik';
import ReactPlayer from 'react-player';
import Loader from 'features/Loader/Loader';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';

import 'shared/components/check-box/CheckBox.scss';

import FileUpload from './FileUpload';

export default function MovementField({
  title,
  urlFieldName,
  sizeFieldName,
  ratingFieldName,
  dysfunctionFieldName,
  dysfunctions,
  addToFilesToBeDeleted
}) {
  const [uploading, setUploading] = useState(false);
  const [urlField] = useField(urlFieldName);
  const [ratingField] = useField(ratingFieldName);
  const [, dysfunctionMeta] = useField(dysfunctionFieldName);

  return (
    <div className="movement-list-block">
      <h5>{title}</h5>

      {uploading ? (
        <Loader />
      ) : urlField.value && urlField.value.length > 0 ? (
        <VideoField
          urlFieldName={urlFieldName}
          sizeFieldName={sizeFieldName}
          addToFilesToBeDeleted={addToFilesToBeDeleted}
        />
      ) : (
        <UploadVideoField
          urlFieldName={urlFieldName}
          sizeFieldName={sizeFieldName}
          uploading={uploading}
          setUploading={setUploading}
        />
      )}

      <RatingField fieldName={ratingFieldName} />

      {ratingField.value && ratingField.value < 5 && (
        <div id={dysfunctionFieldName} className="movement-list-checklist">
          <span>Dysfunction(s)</span>
          <>
            {dysfunctions.map(x => (
              <DysfunctionItem
                key={x.fieldName}
                label={x.label}
                fieldName={x.fieldName}
              />
            ))}
          </>
          {dysfunctionMeta.touched && dysfunctionMeta.error && (
            <div className="input-feedback">{dysfunctionMeta.error}</div>
          )}
        </div>
      )}
    </div>
  );
}

function UploadVideoField({ urlFieldName, sizeFieldName, setUploading }) {
  return (
    <div className="movement-list-add">
      <FileUpload
        urlFieldName={urlFieldName}
        sizeFieldName={sizeFieldName}
        accept="video/mp4"
        setUploading={setUploading}
        maxSize={30}
        maxSizeError="Max size of the video is 30mega"
      >
        {onClick => (
          <button
            type="button"
            className="btn btn-greyishBrown"
            onClick={onClick}
          >
            <i className="fas fa-plus"></i>
            Add Video
          </button>
        )}
      </FileUpload>
    </div>
  );
}

function VideoField({ urlFieldName, sizeFieldName, addToFilesToBeDeleted }) {
  const [urlField, , urlHelper] = useField(urlFieldName);
  const [, , sizeHelper] = useField(sizeFieldName);

  return (
    <div className="movement-list-video">
      <div className="video-block">
        <ReactPlayer
          light={true}
          url={urlField.value}
          width="100%"
          height="100%"
          playIcon={
            <button className="btn btn-primary">
              <i className="fas fa-play"></i>
            </button>
          }
          playing
          controls
        />
      </div>
      <button
        type="button"
        className="delete-video"
        onClick={() => {
          addToFilesToBeDeleted(urlField.value);
          urlHelper.setValue('');
          sizeHelper.setValue(0);
        }}
      >
        <i className="fas fa-trash"></i>
      </button>
    </div>
  );
}

function RatingField({ label = 'Rating', fieldName }) {
  const [field, meta] = useField(fieldName);

  return (
    <div className="movement-list-rating">
      <span>{label}</span>
      <ButtonToolbar>
        <ToggleButtonGroup type="radio" {...field}>
          <ToggleButton {...field} value="1">
            1
          </ToggleButton>
          <ToggleButton {...field} value="2">
            2
          </ToggleButton>
          <ToggleButton {...field} value="3">
            3
          </ToggleButton>
          <ToggleButton {...field} value="4">
            4
          </ToggleButton>
          <ToggleButton {...field} value="5">
            5
          </ToggleButton>
        </ToggleButtonGroup>
      </ButtonToolbar>
      {meta.touched && meta.error && (
        <div className="input-feedback">{meta.error}</div>
      )}
    </div>
  );
}

function DysfunctionItem({ fieldName, label }) {
  const [field] = useField({ name: fieldName, type: 'checkbox' });

  return (
    <div className="form-check">
      <label className="form-check-label">
        <input type="checkbox" className="form-check-input" {...field} />
        <span>
          <i className="far fa-square"></i> {label}
        </span>
      </label>
    </div>
  );
}
